var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4912_42737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2283 35.8418L54.0135 25.373C54.0135 25.373 62.4299 37.1001 54.0135 53.933C50.9459 60.0681 30.5742 56.1633 31.2283 56.1633V35.8418Z",
    fill: "#D1DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3778 52.4499L74.8835 53.2489C74.8835 53.2489 80.524 68.5134 64.8187 78.8829C59.3872 82.4691 48.1309 82.4569 47.4782 82.7257L47.4676 82.7722C47.4386 82.7555 47.443 82.7402 47.4782 82.7257L54.3778 52.4499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6375 22.966L31.2208 32.0368C29.1208 32.9702 27.75 35.0702 27.75 37.3744V51.0827C27.75 67.2702 38.95 82.4077 54 86.0827C69.05 82.4077 80.25 67.2702 80.25 51.0827V37.3744C80.25 35.0702 78.8792 32.9702 76.7792 32.0368L56.3625 22.966C54.875 22.2952 53.125 22.2952 51.6375 22.966ZM54 53.9702H74.4167C72.8708 65.9869 64.85 76.691 54 80.0452V53.9993H33.5833V37.3744L54 28.3035V53.9702Z",
    fill: "#426DD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4912_42737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory3);
export default __webpack_public_path__ + "static/media/category3.fde107abb1006b369a1ccf9208e6d451.svg";
export { ForwardRef as ReactComponent };